import { Link } from 'react-router-dom';
import { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';

const Navbar = () => {
  const { state } = useContext(CartContext);

  // ===============================
  // ESTADOS DE LAS DOS CAJAS
  // ===============================
  const [comentario, setComentario] = useState('');
  const [suerte, setSuerte] = useState('');

  // ===============================
  // ESTADOS DE MENSAJES
  // ===============================
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  // ===============================
  // ENVIAR LAS DOS CAJAS
  // ===============================
  const enviarComentario = async () => {
    setMensaje('');
    setError('');

    const textoComentario = comentario.trim();
    const textoSuerte = suerte.trim();

    // ===============================
    // VALIDAR PRIMERA CAJA
    // ===============================
    if (!textoComentario) {
      setError('Escribe un comentario antes de enviar.');
      return;
    }

    // ===============================
    // VALIDAR SEGUNDA CAJA
    // ===============================
    if (!textoSuerte) {
      setError('Escribe algo en "Deseame Suerte" antes de enviar.');
      return;
    }

    setEnviando(true);

    try {
      // ===============================
      // ENVIAR TODO EN UN SOLO REGISTRO
      // ===============================
      const response = await fetch(
        'https://marketluz.com/laravel8/public/api/comentarios',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            descripcion: textoSuerte,
            tipo: textoComentario
          })
        }
      );

      const data = await response.json();

      // ===============================
      // ERROR HTTP
      // ===============================
      if (!response.ok) {
        if (data.errors?.descripcion) {
          setError(data.errors.descripcion[0]);
        } else if (data.errors?.tipo) {
          setError(data.errors.tipo[0]);
        } else {
          setError('No se pudo enviar el comentario.');
        }

        return;
      }

      // ===============================
      // ÉXITO
      // ===============================
      setMensaje(
        data.mensaje || 'Comentario enviado correctamente'
      );

      // ===============================
      // LIMPIAR LAS DOS CAJAS
      // ===============================
      setComentario('');
      setSuerte('');

    } catch (error) {
      console.error(
        'Error al enviar comentario:',
        error
      );

      setError(
        'No se pudo conectar con el servidor.'
      );

    } finally {
      setEnviando(false);
    }
  };

  // ===============================
  // ENTER
  // ===============================
  const manejarTecla = (e) => {
    if (e.key === 'Enter') {
      enviarComentario();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">

      <div className="container px-4 px-lg-5">

        {/* ===============================
            LOGO
        =============================== */}
        <Link
          className="navbar-brand fw-bold"
          to="/"
          style={{
            fontFamily: "'Poppins', sans-serif"
          }}
        >
          Market Luz
        </Link>


        {/* ===============================
            BOTÓN RESPONSIVE
        =============================== */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>


        {/* ===============================
            MENÚ
        =============================== */}
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
        >

          <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">

            {/* ===============================
                INICIO
            =============================== */}
            <li className="nav-item">
              <Link
                className="nav-link active"
                to="/"
                style={{
                  fontFamily: "'Poppins', sans-serif"
                }}
              >
                Inicio
              </Link>
            </li>


            {/* ===============================
                NOSOTROS
            =============================== */}
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/about"
                style={{
                  fontFamily: "'Poppins', sans-serif"
                }}
              >
                Nosotros
              </Link>
            </li>


            {/* ===============================
                MURO
            =============================== */}
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/muro"
                style={{
                  fontFamily: "'Poppins', sans-serif"
                }}
              >
                Muro
              </Link>
            </li>


            {/* ===============================
                DOS CAJAS OCULTAS
            =============================== */}
            <li
              className="nav-item ms-lg-4 mt-3 mt-lg-0"
              style={{
                width: '100%',
                display: 'none'
              }}
            >

              <div
                className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center gap-2"
                style={{
                  width: '100%'
                }}
              >

                {/* ===============================
                    DESEAME SUERTE
                =============================== */}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Deseame Suerte"
                  value={suerte}
                  maxLength={150}
                  onChange={(e) => {
                    setSuerte(e.target.value);
                    setMensaje('');
                    setError('');
                  }}
                  onKeyDown={manejarTecla}
                  disabled={enviando}
                  style={{
                    width: '300px',
                    maxWidth: '100%',
                    fontFamily: "'Poppins', sans-serif"
                  }}
                />


                {/* ===============================
                    FIRMA
                =============================== */}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pon tu firma"
                  value={comentario}
                  maxLength={150}
                  onChange={(e) => {
                    setComentario(e.target.value);
                    setMensaje('');
                    setError('');
                  }}
                  onKeyDown={manejarTecla}
                  disabled={enviando}
                  style={{
                    width: '300px',
                    maxWidth: '100%',
                    fontFamily: "'Poppins', sans-serif"
                  }}
                />


                {/* ===============================
                    BOTÓN ENVIAR
                =============================== */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={enviarComentario}
                  disabled={enviando}
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                    whiteSpace: 'nowrap'
                  }}
                >
                  {enviando ? 'Enviando...' : 'Enviar'}
                </button>

              </div>


              {/* ===============================
                  MENSAJE DE ÉXITO
              =============================== */}
              {mensaje && (
                <small
                  className="text-success d-block mt-1"
                  style={{
                    fontFamily: "'Poppins', sans-serif"
                  }}
                >
                  {mensaje}
                </small>
              )}


              {/* ===============================
                  MENSAJE DE ERROR
              =============================== */}
              {error && (
                <small
                  className="text-danger d-block mt-1"
                  style={{
                    fontFamily: "'Poppins', sans-serif"
                  }}
                >
                  {error}
                </small>
              )}

            </li>

          </ul>


          {/* ===============================
              BOTÓN PAGAR OCULTO
          =============================== */}
          <Link
            to="/checkout"
            className="btn btn-success px-4 rounded-pill shadow-sm"
            style={{
              display: 'none'
            }}
          >
            Ir a pagar
          </Link>


          {/* ===============================
              BOTONES DERECHOS OCULTOS
          =============================== */}
          <div
            className="d-flex gap-2 ms-3"
            style={{
              display: 'none'
            }}
          >

            <Link
              to="/login"
              className="btn btn-outline-primary"
              style={{
                display: 'none'
              }}
            >
              <i className="bi bi-person-circle me-1"></i>
              Mi Cuenta
            </Link>


            <Link
              className="nav-link fw-semibold text-danger"
              to="/libro-de-reclamaciones"
            >
              Libro de Reclamaciones
            </Link>


            <Link
              to="/cart"
              className="btn btn-outline-dark"
            >
              <i className="bi bi-cart-fill me-1"></i>
              Carrito

              <span className="badge bg-dark text-white ms-1 rounded-pill">
                {state.cartCount}
              </span>
            </Link>

          </div>

        </div>

      </div>

    </nav>
  );
};

export default Navbar;